module.exports = __webpack_public_path__ + "static/media/marker-blue.c0ab1b92.svg";